<div class="modal-container">
  <div class="modal-header">
    <mat-icon svgIcon="info_icon" class="info-icon"></mat-icon>
  </div>

  <div class="modal-body">
    <p><strong>Aprecidado(a) Asesor(a).</strong></p>

    <p>
      <strong>
        Se confirma que el plazo máximo para radicación correspondiente a la
        {{ data.quincena }} quincena de {{ data.mes }} {{ data.anio }} será el día {{ fechaLimiteFormateada }} 12:00
        PM.
      </strong>
    </p>

    <p><strong>Por favor tener en cuenta lo siguiente:</strong></p>

    <ul>
      <li>
        <strong>
          El asesor deberá enviar UN solo correo con sus adjuntos, esto con el
          fin de agilizar la respuesta, validación y confirmación del mismo.
        </strong>
      </li>
      <li>
        <strong>
          Una vez se radique el correo se inicia el proceso de validación y
          confirmación del mismo, la confirmación no será mayor a 24 horas.
        </strong>
      </li>
      <li>
        <strong>
          Los adjuntos deben enviarse como PDF y legibles para garantizar la
          validación.
        </strong>
      </li>
      <li>
        <strong>
          El único canal de radicación es el correo electrónico
          <a href="mailto:asesoresmp_usc&#64;coomeva.com.co"
            >asesoresmp_usc&#64;coomeva.com.co</a
          >
        </strong>
      </li>
      <li>
        <strong>
          Para los asesores que estén obligados a facturar deberán garantizar el
          envío de su factura y XML al correo de facturación electrónica
          <a href="mailto:facelec.coomevamp&#64;gmail.com"
            >facelec.coomevamp&#64;gmail.com</a
          >
          con copia a
          <a href="mailto:asesoresmp_usc&#64;coomeva.com.co"
            >asesoresmp_usc&#64;coomeva.com.co</a
          >
        </strong>
      </li>
      <li>
        <strong>
          El asunto del correo deberá tener la información de la quincena a
          radicar–nombre–número de identificación.
        </strong>
      </li>
      <li>
        <strong>
          Una vez se reporten las novedades para corrección se deberá tener en
          cuenta el plazo máximo para la actualización o cambio de soportes,
          será el día {{ fechaLimiteFormateada }} hasta las 05:00 PM.
        </strong>
      </li>
      <li>
        <strong>
          Todo correo que llegue posterior a la fecha u hora de radicación se
          tomará como extemporáneo para el día 20 de {{ mesSiguiente }} de {{ anioSiguiente }}, con el fin de
          no alterar el cronograma para validación y pago.
        </strong>
      </li>
    </ul>
  </div>

  <div class="modal-footer">
    <button mat-button class="btn-action" mat-dialog-close>Aceptar</button>
    <button
      mat-button
      class="btn-action btn-secondary"
      (click)="goToComisiones()"
    >
      Ir a mis comisiones
    </button>
  </div>
</div>
